import React from 'react'
import style from './index.module.scss'

export interface Props {
  title: string
}

const FormHeader: React.FC<Props> = (props) => {
  return <h1 className={style.header}>{props.title}</h1>
}

export default FormHeader
